import { useSelector } from 'react-redux';

import { appSelectors } from 'modules/app';
import { selectIsLocaleInitialized } from 'modules/locale';

const useInitializingConfig = () => {
  const isAppInitialized = useSelector(appSelectors.isInitialized);
  const isLocaleInitialized = useSelector(selectIsLocaleInitialized);

  return {
    isAppInitialized,
    isLocaleInitialized,
  };
};

export default useInitializingConfig;
